import { PlusSquareOutlined, StarTwoTone } from '@ant-design/icons';
import { Card, Checkbox, Col, InputNumber, Radio, Row, Space, Form, Input, Button, notification } from 'antd';
import React, { Fragment, useContext, useEffect, useState } from 'react';
import DefaultButton from '../../commonComponents/buttons/button';
import BoxInfoCard from '../../commonComponents/Card/boxInfoCard';
import CustomInput from '../../commonComponents/customInput';
import { useGetDefaults } from '../../hooks/useDefault';
import BoxInfoModal from './boxInfoModal';
import tempImg from '../../assets/images/demo.jpg';
import starIcon from '../../assets/images/starIcon.png';
import './order.scss';
import { OrderContext } from '../../context/orderContext';
import { fetchCompaniesDetailId } from '../../hooks/useCompanies';
import { useQuery } from 'react-query';
import { v4 as uuidv4 } from 'uuid';
import FMSConfigOptions from '../FMSConfigOptions';
import BoxForm from './BoxForm';
import StyleColorLibraryModal from '../StyleColorLibraryModal';

export default function OrderForm2({ createOrder, loading }) {
    const [form] = Form.useForm();
    const [api, contextHolder] = notification.useNotification();
    const { details, address } = useContext(OrderContext);

    const [orderDetails, setOrderDetails] = details;
    
    const onSuccess = values => {
        // debugger;
        // console.log(values);
    };

    // Handle style color library settings save - update form values instead of calling API
    const handleStyleColorLibrarySave = settingsPayload => {
        // Store the complete payload including companyId
        form.setFieldValue('styleColorRefSettings', settingsPayload);
    };

    const { data: defaultList, isLoading, isError, error, isFetching } = useGetDefaults(onSuccess, 'shootType');

    const onFormSubmit = value => {
        const { boxInfo, fmsConfigOptions, orderName, services, totalArticles, styleColorRefSettings } = value;

        const payload = {
            boxInfo: boxInfo?.boxList,
            logisticsType: boxInfo?.boxType,
            clientName: orderDetails.clientName,
            company: orderDetails.company,
            companyCode: orderDetails.companyCode,
            fmsConfigOptions: fmsConfigOptions,
            name: orderName,
            services: services,
            totalArticles: totalArticles,
            styleColorRefLibrarySettings: styleColorRefSettings,
        };

        createOrder(payload);

        console.log({ payload });
    };

    const orderNameValidation = async value => {
        var format = /[ `!@#$^*+\=\[\]{};':"\\|<>\/?~]/;
        if (value && !value.trim()) {
            return Promise.reject(new Error('No spaces allowed'));
        }
        if (value && format.test(value)) {
            return Promise.reject(new Error('Special characters like ! @ # $ ^ * /  | +  = \' " ; : < > ? ~ { } [ ]` are not allowed'));
        }

        return Promise.resolve();
    };

    const cancelOrder = () => {
        setOrderDetails({
            company: '',
        });
    };

    return (
        <>
            <div style={{ marginTop: '60px' }}>
                {contextHolder}
                <div className="order-form-main mx-auto">
                    <Form
                        name="register"
                        onCompositionUpdateCapture={() => {}}
                        onAbort={console.log}
                        onFinish={onFormSubmit}
                        form={form}
                        autoComplete="off"
                    >
                        <Form.Item name="clientName" label="Client Name" initialValue={orderDetails.clientName}>
                            <span
                                style={{
                                    fontWeight: '600',
                                }}
                            >
                                {orderDetails.clientName}
                            </span>
                        </Form.Item>
                        <Form.Item
                            name="orderName"
                            label="Order Name"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please enter order name!',
                                },
                                {
                                    validator: (_, value) => orderNameValidation(value),
                                },
                            ]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            name="totalArticles"
                            label="Number of Article"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please enter article count!',
                                },
                            ]}
                            initialValue={1}
                        >
                            <InputNumber min={1} />
                        </Form.Item>

                        <Form.Item
                            name="services"
                            label="Service Required"
                            rules={[
                                {
                                    type: 'array',
                                    required: true,
                                    message: 'Please select atlease one service',
                                },
                            ]}
                            initialValues={{ options: [] }}
                        >
                            <Checkbox.Group>
                                <Space direction="vertical">
                                    {defaultList?.shootType?.map(option => (
                                        <Checkbox key={option?.name} value={option}>
                                            {option?.name}
                                        </Checkbox>
                                    ))}
                                </Space>
                            </Checkbox.Group>
                        </Form.Item>

                        <Form.Item
                            name="boxInfo"
                            rules={[
                                {
                                    required: true,
                                    type: 'object',
                                },
                                {
                                    validator: async (_, value) => {
                                        console.log('validator', { value });
                                        const { boxType, boxList } = value;
                                        if (boxType == null) {
                                            return Promise.reject('Logistic Type Not Specified!! Please slect a logistics type');
                                        }
                                        if (!boxList?.length) {
                                            return Promise.reject('At least one box is required to create order.');
                                        }
                                        return Promise.resolve();
                                    },
                                },
                            ]}
                        >
                            <BoxForm
                                defaultList={defaultList}
                                onChange={value => {
                                    console.log('box form data:', value);
                                    form.setFieldValue('boxInfo', value);
                                }}
                            />
                        </Form.Item>

                        <Form.Item name="fmsConfigOptions" label="Post production Options">
                            <FMSConfigOptions onChange={value => {}} />
                        </Form.Item>

                        <Form.Item name="styleColorRefSettings" label="Style and Color Library">
                            {orderDetails.company && (
                                <StyleColorLibraryModal
                                    record={{ key: orderDetails.company }}
                                    onSave={handleStyleColorLibrarySave}
                                    inline={true}
                                />
                            )}
                        </Form.Item>

                        <div className="flexAlign-center orderform_btns mt-2">
                            <DefaultButton text="Cancel" customClass="mr-2" clickHandler={cancelOrder} />
                            <Button type="default" htmlType="submit" loading={loading} disabled={loading}>
                                Confirm
                            </Button>
                            {/* <DefaultButton text="Save as Draft" customClass="mr-2" /> */}
                            {/* <DefaultButton text="Confirm" clickHandler={submitOrder} />
                             */}
                        </div>
                    </Form>
                </div>
            </div>
        </>
    );
}
